import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';

export const MultiSelect = ({ label, options, selected, onChange, testId, renderLabel }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const toggle = (val) => {
    onChange(selected.includes(val) ? selected.filter(v => v !== val) : [...selected, val]);
  };

  return (
    <div ref={ref} className="relative">
      <label className="text-[10px] text-gray-500 mb-0.5 block font-medium">{label}</label>
      <button type="button" onClick={() => setOpen(!open)} data-testid={testId}
        className={`w-full px-2 py-1.5 border rounded-lg text-xs text-left flex items-center justify-between gap-1 transition-colors ${selected.length ? 'border-amber-400 bg-amber-50' : 'bg-white hover:bg-amber-50/40'}`}>
        <span className="truncate">
          {selected.length === 0 ? `All ${label}` : selected.length === 1 ? (renderLabel ? renderLabel(selected[0]) : selected[0]) : `${selected.length} selected`}
        </span>
        <ChevronDown className={`w-3 h-3 flex-shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-52 overflow-y-auto" data-testid={`${testId}-dropdown`}>
          <div className="px-2 py-1 border-b flex items-center justify-between">
            <button onClick={() => onChange(options.map(o => o.value))} className="text-[10px] text-amber-700 hover:underline">Select All</button>
            <button onClick={() => onChange([])} className="text-[10px] text-red-500 hover:underline">Clear</button>
          </div>
          {options.map(o => (
            <label key={o.value} className="flex items-center gap-2 px-2 py-1.5 hover:bg-gray-50 cursor-pointer text-xs">
              <input type="checkbox" checked={selected.includes(o.value)} onChange={() => toggle(o.value)}
                className="rounded border-gray-300 text-amber-600 focus:ring-amber-500 w-3.5 h-3.5" />
              <span className="truncate">{o.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};
